import Colcade from "colcade";

/**
 * Colcade
 * ======================================
 * - // https://github.com/desandro/colcade
 * - toggle hidden with btn
 */

const BTN = '.js-colcade-btn'
const GRID = '.js-colcade'
const CLASS = 'show-all-projects'
const INIT_HIDDEN_CLASS = 'grid-item--hide-init'
const HIDDEN_CLASS = 'grid-item--hide'

class ColcadeGrid {
  constructor() {
    this.grid = document.querySelector(GRID)
    this.btn = document.querySelector(BTN)

    if (!this.grid) {
      return false
    }

    this.colcade = this.init()

    document.querySelectorAll('.'+INIT_HIDDEN_CLASS).forEach((el) => {
      el.classList.remove(INIT_HIDDEN_CLASS)
      el.classList.add(HIDDEN_CLASS)
    })

    if(this.btn){
      this.btn.addEventListener('click', this.show, false)
    }
  }

  init = () => {
    return new Colcade( this.grid, {
      columns: '.grid-col',
      items: '.grid-item'
    });
  }

  show = () => {
    document.body.classList.add(CLASS)
  }
}

new ColcadeGrid()
